export default "__VITE_ASSET__CqRMStjF__"